import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ClockIcon from '../../icons/ClockIcon'
import BaseWidget from '../../components/common/BaseWidget'
import EngagementWidget from '../../components/common/EngagementWidget/EngagementWidget'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  }
}))

const formatLabel = text =>
  text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))

const ScanningSchedule = ({ score, isLoading }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const selectedScoreKey = score > 7 ? 'positive' : score > 4 ? 'neutral' : 'negative'

  const scoreOptions = [
    {
      key: 'negative',
      fillColor: '#FFEEEE',
      strokeColor: '#EB5757',
      icon: ClockIcon,
      label: formatLabel(t('pages.copilotControl.widgets.scanningSchedule.negativeLabel')),
      description: t('pages.copilotControl.widgets.scanningSchedule.negativeDescription')
    },
    {
      key: 'neutral',
      fillColor: '#FFF5E1',
      strokeColor: '#FFBD39',
      icon: ClockIcon,
      label: formatLabel(t('pages.copilotControl.widgets.scanningSchedule.neutralLabel')),
      description: t('pages.copilotControl.widgets.scanningSchedule.neutralDescription')
    },
    {
      key: 'positive',
      fillColor: '#E9FDF3',
      strokeColor: '#26C36F',
      icon: ClockIcon,
      label: formatLabel(t('pages.copilotControl.widgets.scanningSchedule.positiveLabel')),
      description: t('pages.copilotControl.widgets.scanningSchedule.positiveDescription')
    }
  ]

  return (
    <BaseWidget carousel={false} className={classes.root}>
      <EngagementWidget
        comingSoon={true}
        isLoading={isLoading}
        title={t('pages.copilotControl.widgets.scanningSchedule.title')}
        engagementType={CopilotEngagementTypes.Scheduling}
        scoreOptions={scoreOptions}
        selectedScore={scoreOptions.find(o => o.key === selectedScoreKey)}
      />
    </BaseWidget>
  )
}

export default ScanningSchedule
